import $ from 'jquery';
import _ from 'lodash';

export default function(o){

  return function(){

    var totalWidth = 0

    var rows = o.rows
    var header = o.header

    rows
    .children()
    .first()
    .children()
    .each(function(i){

      var width = $(this).outerWidth()
      totalWidth += width

      header
      .children()
      .eq(i)
      .css({
        width: width + 'px',
      })

      header
      .children()
      .eq(i)
      .children()
      .eq(0)
      .css({
        width: width + 'px',
      })

      header
      .children()
      .eq(i)
      .children()
      .eq(1)
      .css({
        width: width + 'px',
      })

    })

    header.css({width: totalWidth + 'px'})
    rows.css({width: totalWidth + 'px'})

  }

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/table/lib/layout/layout.js